import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { AppShell } from '@/components/layout/AppShell'

const HomePage = lazy(() => import('@/features/home/HomePage'))
const CallsPage = lazy(() => import('@/features/calls/CallsPage'))
const CallDetailPage = lazy(() => import('@/features/call-detail/CallDetailPage'))
const LiveCallPage = lazy(() => import('@/features/live-call/LiveCallPage'))
const NewCallPage = lazy(() => import('@/features/new-call/NewCallPage'))
const ContactsPage = lazy(() => import('@/features/contacts/ContactsPage'))
const SettingsPage = lazy(() => import('@/features/settings/SettingsPage'))
const BusinessDetailsPage = lazy(() => import('@/features/settings/BusinessDetailsPage'))
const VerificationPage = lazy(() => import('@/features/verification/VerificationPage'))
const CreditsPage = lazy(() => import('@/features/billing/CreditsPage'))
const SubscriptionPage = lazy(() => import('@/features/billing/SubscriptionPage'))
const BusinessSubscriptionPage = lazy(() => import('@/features/billing/BusinessSubscriptionPage'))
const ManageSubscriptionPage = lazy(() => import('@/features/billing/ManageSubscriptionPage'))
const ApiKeysPage = lazy(() => import('@/features/api-keys/ApiKeysPage'))
const KitchenSinkPage = lazy(() => import('@/features/dev/KitchenSinkPage'))

function page(element: React.ReactNode) {
  return <Suspense fallback={null}>{element}</Suspense>
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: page(<HomePage />) },
      { path: 'calls', element: page(<CallsPage />) },
      { path: 'call/:callSid', element: page(<CallDetailPage />) },
      { path: 'live/:callSid', element: page(<LiveCallPage />) },
      { path: 'new/:number?', element: page(<NewCallPage />) },
      { path: 'contacts', element: page(<ContactsPage />) },
      { path: 'settings', element: page(<SettingsPage />) },
      { path: 'settings/business', element: page(<BusinessDetailsPage />) },
      { path: 'verification', element: page(<VerificationPage />) },
      { path: 'credits', element: page(<CreditsPage />) },
      { path: 'subscription', element: page(<SubscriptionPage />) },
      { path: 'subscription/business', element: page(<BusinessSubscriptionPage />) },
      { path: 'subscription/manage', element: page(<ManageSubscriptionPage />) },
      { path: 'keys', element: page(<ApiKeysPage />) },
      ...(import.meta.env.DEV ? [{ path: 'dev/kitchen-sink', element: page(<KitchenSinkPage />) }] : []),
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
